import type { ReactNode } from 'react'
import React, { useContext } from 'react'

import styles from './index.module.css'
import type { CardVariant, ICardContext } from '..'
import { CardContext } from '..'
import { BreakpointSizes, useBrowser } from '@s4l/utils/hooks/useBrowser'

export interface IBodyProps {
  children: ReactNode
  variant?: CardVariant
}

function Body(props: IBodyProps) {
  const { children, variant } = props

  const { url, Link, onClick } = useContext<ICardContext>(CardContext)

  const { activeBreakpoint } = useBrowser()

  const target = activeBreakpoint >= BreakpointSizes.L ? '_blank' : '_self'

  return (
    <Link
      className={styles.container}
      href={url}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      data-variant={variant}
      data-testid="card-body"
      onClick={onClick}
    >
      {children}
    </Link>
  )
}

Body.displayName = 'Card.Body'

export { Body }
